import { useDialogStore } from "@shared/common/contexts/dialog/useDialogStore";
import { Dialog, DialogContentContainer, ScrollContainer } from "@shared/EDS/components/Dialog";
import { JSX, useId } from "react";
import { ServiceTasksOverviewWrapper } from "./ServiceTasksOverviewWrapper";
import { PrerequisiteItem } from "@shared/components/SidePanel/PrerequisiteItem";

export function ServiceTasksOverviewDialog(): JSX.Element {
  const serviceTaskOverviewListDialogId = useId();
  const openDialog = useDialogStore((state) => state.openDialog);
  const closeDialog = useDialogStore((state) => state.closeDialog);

  return (
    <>
      <PrerequisiteItem
        title="Servicetaken"
        onClick={() => openDialog(serviceTaskOverviewListDialogId)}
      />
      <Dialog dialogId={serviceTaskOverviewListDialogId} title="Servicetaken" maxWidth="95svw">
        <DialogContentContainer>
          <ScrollContainer $height={"calc(85vh - 20px - (20px + 20px + 24px))"}>
            <ServiceTasksOverviewWrapper />
          </ScrollContainer>
          <div className="flex justify-end gap-xs px-l pt-l pb-0 [&>button]:px-5 [&>button]:py-xs">
            <tractie-button
              data-testid="service-tasks-overview-close-button"
              level="primary"
              onClick={() => closeDialog(serviceTaskOverviewListDialogId)}
            >
              Sluiten
            </tractie-button>
          </div>
        </DialogContentContainer>
      </Dialog>
    </>
  );
}
